<template>
  <home :showLink="showLink">
    <template slot="alerts">
      <div>
        <div>
          <global-title :title="$t('menu.homeDemo')"></global-title>
        </div>
        <div class="switch_btn" @click="switchAccType">
          <img src="@/assets/images/switch_icon.png" alt />
          <span> {{ $t('home.switchAccType') }}</span>
        </div>
      </div>
    </template>

    <div id="accounts">
      <div class="content_box">
        <AccountSelector
          :accountType="accountType"
          :accountStatus.sync="accountStatus"
          :platformType.sync="platformType"
          :viewType.sync="viewType"
        />
        <div>
          <DemoAccount
            :viewType="viewType"
            :resultDemoAccountList="resultDemoAccountList"
            :passwordVisible.sync="passwordVisible"
            :resetBalVisible.sync="resetBalVisible"
            :number.sync="number"
            @triggerLeverageDemo="triggerLeverageDemo"
          ></DemoAccount>
        </div>
      </div>
    </div>

    <template slot="components">
      <!-- CHANGE LEVERAGE 弹框开始 -->
      <ChangeLeverage
        :changeLeverageVisible.sync="changeLeverageVisible"
        :showTNC="showTNC"
        :leverageConfirmVisible.sync="leverageConfirmVisible"
        :leverageChangeSubmitSuccess.sync="leverageChangeSubmitSuccess"
        :leverageChangeSubmitFail.sync="leverageChangeSubmitFail"
        :leverageChangeSubmitReject.sync="leverageChangeSubmitReject"
        :leverageChangeAuditSuccess.sync="leverageChangeAuditSuccess"
        :leverageChangeSubmitTimeOut.sync="leverageChangeSubmitTimeOut"
        method="live"
      ></ChangeLeverage>
      <!-- CHANGE LEVERAGE 弹框结束 -->

      <!-- CHANGE LEVERAGE confirm 弹框开始 -->
      <Common :homeVisible.sync="leverageConfirmVisible" :showFooter="false">
        <div class="dialog_body" v-if="leverageChangeSubmitSuccess">
          <img src="@/assets/images/dialog_true_circle.png" alt />
          <p
            v-html="
              leverageChangeAuditSuccess
                ? $t('home.leverage.changeLeverageAutoComplete')
                : $t('home.leverage.changeLeverageConfirm')
            "
          ></p>
        </div>
        <div class="dialog_body" v-if="leverageChangeSubmitFail">
          <img src="@/assets/images/dialog_false.png" alt />
          <p v-html="$t('home.leverage.changeLeverageFail')"></p>
        </div>
        <div class="dialog_body" v-if="leverageChangeSubmitReject">
          <img src="@/assets/images/dialog_false.png" alt />
          <p v-html="$t('home.leverage.changeLeverageReject')"></p>
        </div>
        <div class="dialog_body" v-if="leverageChangeSubmitTimeOut">
          <img src="@/assets/images/dialog_false.png" alt />
          <p v-html="$t('home.leverage.changeLeverageDefault', { supportEmail: GLOBAL_CONTACT_EMAIL })"></p>
        </div>
      </Common>
      <!-- CHANGE LEVERAGE confirm 弹框结束 -->

      <!-- CHANGE LEVERAGE already 弹框开始 -->
      <Common :homeVisible.sync="leverageAlreadyVisible" :showFooter="false">
        <img src="@/assets/images/dialog_true_circle.png" alt />
        <p>{{ $t('home.leverage.alreadyApplied', { platform: $config.info.fullName }) }}</p>
      </Common>
      <!-- CHANGE LEVERAGE already 弹框结束 -->

      <!-- 点击小锁弹框开始 -->
      <Password
        :passwordVisible.sync="passwordVisible"
        :forgotPwdVisible.sync="forgotPwdVisible"
        :showFooter="false"
        :number="number"
        :uuid="uuid"
        @forgotPwdClick="forgotPwdClick"
      ></Password>
      <!-- 点击小锁弹框结束 -->

      <!-- 点击 CHANGE PASSWORD  表单弹框开始 -->
      <ChangePassword
        :changePasswordVisible.sync="changePasswordVisible"
        :pwdConfirmVisible.sync="pwdConfirmVisible"
        :showFooter="false"
        :number="number"
        :isDemo="isDemo"
        @forgotPwdClick="forgotPwdClick"
      ></ChangePassword>
      <!-- 点击 CHANGE PASSWORD  表单弹框结束 -->

      <!-- CHANGE PASSWORD confirm 弹窗提示信息开始 -->
      <Common :homeVisible.sync="pwdConfirmVisible" :showFooter="false">
        <img src="@/assets/images/dialog_true_circle.png" alt />
        <p v-html="$t('home.pw.confirm')"></p>
      </Common>
      <!-- CHANGE PASSWORD confirm 弹窗提示信息开始 -->

      <!-- FORGOT PASSWORD 开始 -->
      <Common :homeVisible.sync="forgotPwdVisible" :showFooter="false">
        <img src="@/assets/images/dialog_email.png" alt />
        <div v-html="$t('home.pw.email')"></div>
      </Common>
      <!-- FORGOT PASSWORD 结束 -->

      <!-- active Confirm 弹框开始 -->
      <Common :homeVisible.sync="activateConfirmVisible" :showFooter="false">
        <img src="@/assets/images/dialog_true_circle.png" alt />
        <p v-html="$t('home.activate.confirm')"></p>
      </Common>
      <!-- active Confirm 弹框结束 -->

      <!-- Reset Negative Balance dialog start -->
      <ResetNegativeBalanceDialog
        :resetConfirmVisible.sync="showResetNegativeDialog"
        @actionResetNegativeBalance="actionResetNegativeBalance"
      ></ResetNegativeBalanceDialog>
      <!-- Reset Negative Balance dialog end -->

      <!-- 点击 DEMO RESET BALANCE 开始 -->
      <ResetBalance :resetBalVisible.sync="resetBalVisible" :number="number" @resetTable="getDemo" :showFooter="false">
      </ResetBalance>
      <!-- 点击 DEMO RESET BALANCE 结束 -->

      <App :appVisible.sync="appVisible"></App>
    </template>
  </home>
</template>

<script>
import {
  apiQueryLeverageStatuses,
  apiReq_reset_mt4_password,
  apiRestAccountBalance,
  apiHomeGet_demo_accs
} from '@/resource';
import App from '@/components/home/App';
import Common from '@/components/home/Common';
import Active from '@/components/home/Active';
import ResetNegativeBalanceDialog from '@/components/home/ResetNegativeBalanceDialog';
import Password from '@/components/home/Password';
import ChangePassword from '@/components/home/ChangePassword';
import ChangeLeverage from '@/components/home/ChangeLeverage';
import Home from '@/components/template/Home';
import changeLeverageMixins from '@/mixins/page/home/changeLeverage';
import hideAccountMixins from '@/mixins/page/home/hideAccount';
import GlobalTitle from '@/components/global/title';
import { formatNumber, formaNegativeNumber } from '@/util/filter';
import AccountSelector from '@/components/home/AccountSelector';
import DemoAccount from '@/components/home/DemoAccount';
import ResetBalance from '@/components/home/ResetBalance';
import isMobile from '@/mixins/isMobile';
import { RegisterRoutePath } from '@/router/registerRoutes';

export default {
  name: 'homePage',
  components: {
    App,
    Common,
    Active,
    Password,
    ChangePassword,
    ChangeLeverage,
    Home,
    ResetNegativeBalanceDialog,
    GlobalTitle,
    AccountSelector,
    DemoAccount,
    ResetBalance
  },
  mixins: [changeLeverageMixins, hideAccountMixins, isMobile],
  data() {
    return {
      uuid: this.$store.state.common.uuid,
      number: null,
      allMetaTraderAccounts: [],
      mt4AccountTableData: [],
      mt5AccountTableData: [],
      leverageStatus: {},
      leverageAlreadyVisible: false,
      passwordVisible: false,
      changePasswordVisible: false,
      // 小锁弹出框
      pwdConfirmVisible: false,
      forgotPwdVisible: false,
      // active 弹框
      activateVisible: false,
      activateConfirmVisible: false,
      reActivateMetaTraderLogin: null,
      isDemo: true,
      appVisible: false,
      showResetNegativeDialog: false,
      showResetNegativeColumnMT4: false,
      showResetNegativeColumnMT5: false,
      resetNegativeAccountNumber: 0,
      accountStatus: [],
      platformType: null,
      viewType: 'card',
      accountType: 'demo',
      allMetaDemoAccounts: [],
      showTNC: true,
      resetBalVisible: false
    };
  },
  mounted() {
    this.$store.dispatch('common/actionPoiAuditStatus');
    this.$store.dispatch('common/actionPoaAuditStatus');

    this.getDemo();

    let live = JSON.parse(localStorage.getItem('live'));
    if (live) {
      this.accountStatus = live.accountStatus;
      this.platformType = live.platformType;
    }
  },
  computed: {
    showLink() {
      return this.allMetaTraderAccounts.length > 1;
    },
    showDiffTable() {
      return this.allMetaTraderAccounts.length == 1 && !this.idPass;
    },
    showDiffButton() {
      return this.allMetaTraderAccounts.length == 1 && !this.idPass && this.allMetaTraderAccounts[0].mt4_account != '-';
    },
    noDepositIsLogin() {
      return this.$store.state.common.noDepositIsLogin;
    },
    resultAccountList() {
      let all = this.allMetaTraderAccounts;
      let result = all.filter(item => {
        try {
          item.currencyLogo = require(`@/assets/images/currency/${item.currency}.png`);
        } catch (error) {
          item.currencyLogo = null;
        }

        if (this.accountStatus.length !== 0) {
          if (this.platformType) {
            return this.accountStatus.some(
              filterStatus => item.status === filterStatus && item.specialPlatformType === this.platformType
            );
          } else {
            return this.accountStatus.includes(item.status);
          }
        } else {
          if (this.platformType) {
            return item.specialPlatformType === this.platformType;
          } else {
            return all;
          }
        }
      });
      return result;
    },
    resultDemoAccountList() {
      let all = this.allMetaDemoAccounts;
      let result = all.filter(item => {
        try {
          item.currencyLogo = require(`@/assets/images/currency/${item.currency}.png`);
        } catch (error) {
          item.currencyLogo = null;
        }

        if (this.accountStatus.length !== 0) {
          if (this.platformType) {
            return this.accountStatus.some(
              filterStatus => item.status === filterStatus && item.specialPlatformType === this.platformType
            );
          } else {
            return this.accountStatus.includes(item.status);
          }
        } else {
          if (this.platformType) {
            return item.specialPlatformType === this.platformType;
          } else {
            return all;
          }
        }
      });
      return result;
    }
  },
  methods: {
    formatNumber,
    formaNegativeNumber,
    getDemo() {
      apiHomeGet_demo_accs().then(resp => {
        this.allMetaDemoAccounts = resp.data.data || [];
        this.formatAccounts('demo');
      });
    },
    formatAccounts(type) {
      if (type == 'live') {
        this.allMetaTraderAccounts.forEach((element, i) => {
          if (element.status != 1) {
            this.formatPendingAccount(element);
          }
          if (element.isArchive == 1 || element.isArchive == 2) {
            this.formatArchieveAccount(element);
          }
          if (element.serverCategory === '4') {
            this.$set(this.allMetaTraderAccounts[i], 'specialPlatformType', 4);
          }
          if (element.serverCategory === '5' || element.serverCategory === '6') {
            this.$set(this.allMetaTraderAccounts[i], 'specialPlatformType', 5);
          }
          if (element.status === 1) {
            this.$set(this.allMetaTraderAccounts[i], 'leverageStatus', 1);
          }
          this.setStatus(element);
        });
      } else {
        this.allMetaDemoAccounts.forEach((element, i) => {
          if (element.platform === '4') {
            this.$set(this.allMetaDemoAccounts[i], 'specialPlatformType', 4);
          }
          if (element.platform === '5') {
            this.$set(this.allMetaDemoAccounts[i], 'specialPlatformType', 5);
          }
          this.setStatus(element);
        });
      }
    },
    formatPendingAccount(account) {
      account.equity = '-';
      account.mt4_account = '-';
    },
    formatArchieveAccount(account) {
      account.equity = '-';
      account.currency = '-';
    },
    setStatus(account) {
      if (account.isArchive && (account.isArchive == 1 || account.isArchive == 2)) {
        account.status = 'Inactive';
        return;
      }
      if (account.status == 1) {
        account.status = 'Active';
        return;
      }
      if (account.status == 0) {
        account.status = 'Processing';
        return;
      }
      if (account.status == 2) {
        account.status = 'Rejected';
        return;
      }

      if (account.status == 3) {
        account.status = 'Pending';
        return;
      }

      if (account.status == 'active') {
        account.status = 'Active';
        return;
      }

      if (account.status == 'expired') {
        account.status = 'Expired';
        return;
      }
    },
    queryLeverageStatus() {
      apiQueryLeverageStatuses({
        user_id: this.uuid
      }).then(resp => {
        this.leverageStatus = resp.data;
        this.updateLeverageStatus();
        this.seperateAccounts();
      });
    },
    updateLeverageStatus() {
      this.resultAccountList.forEach(element => {
        if (element.mt4_account == '-' || element.mt4_account == null) {
          return;
        }
        if (this.leverageStatus[element.mt4_account.toString()]) {
          if (this.leverageStatus[element.mt4_account.toString()].status == 0) {
            element.leverageStatus = 0;
            return;
          }
        }
        element.leverageStatus = 1;
      });
    },
    seperateAccounts() {
      this.mt4AccountTableData = [];
      this.mt5AccountTableData = [];

      this.allMetaTraderAccounts.map(m =>
        m.serverCategory === '5' ? this.mt5AccountTableData.push(m) : this.mt4AccountTableData.push(m)
      );
    },
    showleverageAlreadyInProcessPopUp() {
      this.leverageAlreadyVisible = true;
    },
    // 点击小锁 第一个弹窗
    handleLock(index, row) {
      this.passwordVisible = true;
      this.number = row.mt4_account;
    },
    forgotPwdClick() {
      this.sendResetPasswordEmail().then(result => {
        let vm = this;
        if (result) {
          this.passwordVisible = false;
          this.forgotPwdVisible = true;
        } else {
          this.$message({
            message: vm.$t('home.pw.error'),
            type: 'error'
          });
        }
      });
    },
    sendResetPasswordEmail() {
      const baseUrl = location.protocol + '//' + location.hostname;
      return apiReq_reset_mt4_password({
        userId: this.uuid,
        mtAccount: this.number,
        baseUrl: baseUrl,
        isDemo: this.isDemo
      }).then(resp => {
        if (resp.data.code == 0) {
          if (resp.data.data) {
            console.log('The reset password email is sent out');
            return Promise.resolve(true);
          } else {
            console.log('failed to sent out the reset password');
          }
        } else {
          console.log('Errors happened when applying for the reset password emails');
        }
        return Promise.resolve(false);
      });
    },
    resetNegativeBalance(row) {
      this.resetNegativeAccountNumber = row.mt4_account;

      if (row.credit > 0) {
        this.showResetNegativeDialog = true;
      } else {
        this.actionResetNegativeBalance();
      }
    },
    actionResetNegativeBalance() {
      apiRestAccountBalance(this.resetNegativeAccountNumber).then(res => {
        res.data.data.code === 0
          ? this.resetNegativeBalanceSuccess()
          : this.$message({ message: this.$t(`home.reset.error${res.data.data.code}`), type: 'error' });
      });
    },
    goLiveAccount() {
      this.$router.push(RegisterRoutePath.register);
    },
    switchAccType() {
      this.$router.push('/authority');
    },
    triggerLeverageDemo(value) {
      this.leverageDemoClick(value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/home.scss';
</style>
